module.exports = __webpack_public_path__ + "img/neighbor-7-supp.4acc133d.svg";